import React from "react";
import PropTypes from "prop-types";
import { graphql, useStaticQuery } from "gatsby";
import { mapCards } from "../../utils/map-cards";

const Partners = ({ children }) => {
  const data = useStaticQuery(graphql`
    query PartnersQuery {
      wpPages {
        partners(first: 3000) {
          nodes {
            id
            link
            date
            title
            contentTypeName
            featuredImage {
              node {
                sourceUrl
                altText
              }
            }
            terms {
              nodes {
                slug
                taxonomyName
              }
            }
            acf
            taxonomies
          }
        }
      }
    }
  `);
  let filteredCards = data.wpPages.partners.nodes;

  filteredCards = mapCards(filteredCards);
  filteredCards = filteredCards.sort((a, b) => a - b);
  return children(filteredCards);
};

export default Partners;
